import React from "react";
import styles from "./Sports.css";
import PropTypes from "prop-types";
import NewsletterSubscribeForm from "../../../components/Library/NewsletterSubscribeForm/NewsletterSubscribeForm";
import FetchOnSubmit from "../../../components/Library/FetchOnSubmit/FetchOnSubmit";
import validateEmail from "../../../utils/validateEmail";

export default function LandingPage({ updateSubmitted, referralCode }) {
  return (
    <div className={styles.root}>
      <div className={styles.landing}>
        <div className={styles.content}>
          <h1>
            Your friend is inviting you to <strong>Axios Sports</strong>
          </h1>
          <p>A daily sports page delivered directly to your inbox</p>

          <FetchOnSubmit
            method="POST"
            url="/refer/send_optin/"
            onSuccess={() => updateSubmitted(true)}
            validate={validateEmail}
          >
            {({ status, error, submit, reset }) => {
              return (
                <NewsletterSubscribeForm
                  formClassName="referral-form"
                  list={""}
                  submit={({ email }) =>
                    submit({
                      email,
                      referred_to_list: "newsletter_axiossports",
                      referred_by: referralCode,
                    })
                  }
                  status={status}
                  error={error}
                  reset={reset}
                  placeholder={"Your Email Address"}
                  userVars={{}}
                  submitButtonText="Subscribe"
                />
              );
            }}
          </FetchOnSubmit>
          <a
            href="https://www.axios.com/newsletters/axios-sports"
            target="_blank"
            className={styles.link}
          >
            Want a sneak peak? Read the latest version here.
          </a>
        </div>
        <div className={styles.image}>
          <img
            src={require("assets/img/phone-referral-sports.png")}
            alt="Sign up for Sports!"
          />
        </div>
      </div>
    </div>
  );
}

LandingPage.propTypes = {
  referralCode: PropTypes.string.isRequired,
  updateSubmitted: PropTypes.func.isRequired,
};
